import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import "../css/funds.css";

export default function Funds() {
  const [items,          setItems]          = useState([]);
  const [animatedCounts, setAnimatedCounts] = useState({});
  const [loading,        setLoading]        = useState(true);

  /* ── Fetch from Firestore ──────────────────────────────── */
  useEffect(() => {
    const fetchFunds = async () => {
      try {
        const q    = query(collection(db, "Funds"), orderBy("createdAt", "asc"));
        const snap = await getDocs(q);
        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setItems(docs);
      } catch {
        // fallback without ordering if index not ready
        try {
          const snap = await getDocs(collection(db, "Funds"));
          setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        } catch {}
      }
      setLoading(false);
    };

    fetchFunds();
  }, []);

  /* ── Animated counters (run when items load) ───────────── */
  useEffect(() => {
    if (!items.length) return;

    const timers = [];

    items.forEach((item) => {
      let current = 0;
      const end       = item.count || 0;
      const duration  = 3000;
      const increment = Math.ceil(end / (duration / 20));

      const counter = setInterval(() => {
        current += increment;
        if (current >= end) {
          current = end;
          clearInterval(counter);
        }
        setAnimatedCounts((prev) => ({ ...prev, [item.id]: current }));
      }, 20);

      timers.push(counter);
    });

    return () => timers.forEach(clearInterval);
  }, [items]);

  /* ── Loading skeleton ──────────────────────────────────── */
  if (loading) {
    return (
      <div className="funds">
        <div className="funds-container">
          <div className="funds-row">
            {[1,2,3,4,5,6,7,8].map((i) => (
              <div key={i} className="fund-card fund-card--skeleton">
                <div className="fund-icon fund-icon--skeleton" />
                <div className="facts-text">
                  <div className="skeleton-line skeleton-line--count" />
                  <div className="skeleton-line skeleton-line--label" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  /* ── No data fallback ──────────────────────────────────── */
  if (!items.length) return null;

  /* ── Render ────────────────────────────────────────────── */
  return (
    <div className="funds">
      <div className="funds-container">
        <div className="funds-row">
          {items.map((item) => (
            <div className="fund-card" key={item.id}>
              <img
                src={item.iconUrl}
                alt={item.label}
                className="fund-icon"
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <div className="facts-text">
                {/* count with + sign */}
                <h3>{animatedCounts[item.id] ?? 0}+</h3>
                <p>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}